<template>
  <BreadCrumb PageTitle="Liste des produits" />
  <ProductList />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ProductList from "../../components/Stock/ProductList.vue";

export default defineComponent({
  name: "ProductListPage",
  components: {
    BreadCrumb,
    ProductList,
  },
});
</script>